/**
 * Meta Facebook App ID，须与 Firebase Console → Authentication → Facebook 为同一应用。
 * 通过 NEXT_PUBLIC_FACEBOOK_APP_ID 配置。
 */
export function getFacebookAppId(): string {
    // const appId = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID;
    const appId = '2159073668213781';
    if (!appId) {
        throw new Error(
            'Facebook App ID is not configured. Set NEXT_PUBLIC_FACEBOOK_APP_ID (same app as Firebase Facebook provider).'
        );
    }
    return appId;
}
